export const setInLocalStorage = (key: string, value: unknown) => {
  if (value) {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.removeItem(key);
  }
};

export const getFromLocalStorage = <T = unknown>(key: string) => {
  const jsonValue = localStorage.getItem(key);

  return jsonValue ? (JSON.parse(jsonValue) as T) : null;
};
